/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return */
import { assign, createMachine, Interpreter } from 'xstate-v4'
import { ChargeType, ChargeTypesInput, PitchType } from './types'

export interface ChargeTypesContext {
  pitchtypes: PitchType[]
  chargetypes: ChargeType[]
  params: ChargeTypesInput | null
  hasAvailability: boolean
}

function getInitialChargeTypesContext(): ChargeTypesContext {
  return {
    pitchtypes: [],
    chargetypes: [],
    hasAvailability: false,
    params: null,
  }
}

interface ChargeTypesEvents {
  type: 'FETCH_CHARGETYPES'
  params: ChargeTypesInput
  pitchtypes: PitchType[]
}

export function returnChargeTypesStateMachine() {
  return createMachine<ChargeTypesContext, ChargeTypesEvents>(
    {
      id: 'chargeTypesMachine',
      context: getInitialChargeTypesContext(),
      initial: 'idle',
      on: {
        FETCH_CHARGETYPES: 'fetchingChargeTypes',
      },
      states: {
        idle: {},
        fetchingChargeTypes: {
          entry: assign({
            params: (_, { params }) => params,
            pitchtypes: (_, { pitchtypes }) => pitchtypes,
          }),
          invoke: {
            src: 'searchService',
            onDone: {
              actions: assign({
                // TODO: Add proper types for XState event data

                chargetypes: (_, { data }) => data,

                hasAvailability: (_, { data }) =>
                  data.some((chargetype) => chargetype.state === 'available'),
              }),
              target: 'success',
            },
            onError: {
              actions: 'logError',
              target: 'error',
            },
          },
        },
        success: {},
        error: {},
      },
    },
    {
      actions: {
        logError: () => {
          throw new Error('chargeTypesStateMachine logError not implemented')
        },
      },
    },
  )
}

export type ChargeTypesMachineInterpreter = Interpreter<
  ChargeTypesContext,
  any,
  ChargeTypesEvents
>
